import { HttpDeprecatedService } from '@commons/core/transport/http-deprecated.service';

export interface IResponderService {
  buildRespMessageEntryRequest(data, size, from, flowsUuid);
  execSearchRequest(url, object);
  execRespMessageRequest(json, size, from, flowsUuid);
  addPlayToRespMessage(respMessageUuid);
  deleteRespMessage(respMessageId);
  getDomainsOfPerimeter();
  getPerimeters();
  getFlows();
  getRespMessageStatus(channelId);
  setRespMessageToRead(messageUuid);
}

export class ResponderService implements IResponderService {
  static $inject: Array<string> = ['httpDeprecated'];

  constructor(private readonly httpDeprecated: HttpDeprecatedService) {}

  buildRespMessageEntryRequest(data, size, from, flowsUuid) {
    if (
      !data.phoneCallerFilter &&
      !data.calledPhoneFilter &&
      !data.calledPhoneAliasFilter &&
      !data.flowFilter &&
      !data.beginDateFilter &&
      !data.endDateFilter &&
      !data.durationFilter
    ) {
      return {
        types: ['responder'],
        query: {
          bool: {
            must: [{ terms: { 'mediaEntryPoint.uuid': flowsUuid } }],
          },
        },
        sort: { beginDate: { order: 'desc' } },
        size: size,
        from: from,
      };
    } else {
      let query = {
        types: ['responder'],
        query: {
          bool: {
            must: [{ terms: { 'mediaEntryPoint.uuid': flowsUuid } }],
            filter: {
              bool: {
                must: new Array(),
              },
            },
          },
        },
        sort: { beginDate: { order: 'desc' } },
        size: size,
        from: from,
      };

      if (data.phoneCallerFilter) {
        let phoneCallerQuery = {
          bool: {
            must: [
              {
                term: {
                  contactUri: data.phoneCallerFilter,
                },
              },
            ],
          },
        };
        query.query.bool.filter.bool.must.push(phoneCallerQuery);
      }

      if (data.calledPhoneFilter) {
        let calledPhoneQuery = {
          bool: {
            must: [
              {
                term: {
                  calledUri: data.calledPhoneFilter,
                },
              },
            ],
          },
        };
        query.query.bool.filter.bool.must.push(calledPhoneQuery);
      }

      if (data.calledPhoneAliasFilter) {
        let calledPhoneAliasQuery = {
          bool: {
            must: [
              {
                term: {
                  'calledName.keyword': data.calledPhoneAliasFilter,
                },
              },
            ],
          },
        };
        query.query.bool.filter.bool.must.push(calledPhoneAliasQuery);
      }

      if (data.flowFilter && data.flowFilter.uuid !== undefined) {
        let flowQuery = {
          bool: {
            must: [
              {
                term: {
                  'mediaEntryPoint.uuid': data.flowFilter.uuid,
                },
              },
            ],
          },
        };
        query.query.bool.filter.bool.must.push(flowQuery);
      }

      if (data.beginDateFilter && data.endDateFilter) {
        let dateQuery = {
          range: {
            beginDate: {
              from: data.beginDateFilter,
              to: data.endDateFilter,
            },
          },
        };
        query.query.bool.filter.bool.must.push(dateQuery);
      } else {
        if (data.beginDateFilter) {
          let dateDebutQuery = {
            range: {
              beginDate: {
                from: data.beginDateFilter,
              },
            },
          };
          query.query.bool.filter.bool.must.push(dateDebutQuery);
        }
        if (data.endDateFilter) {
          let dateFinQuery = {
            range: {
              beginDate: {
                to: data.endDateFilter,
              },
            },
          };
          query.query.bool.filter.bool.must.push(dateFinQuery);
        }
      }

      if (data.durationFilter) {
        let durationQuery = {
          range: {
            messageDuration: {
              gt: data.durationFilter,
            },
          },
        };
        query.query.bool.filter.bool.must.push(durationQuery);
      }

      return query;
    }
  }

  execSearchRequest(url, object) {
    let config = {
      headers: {
        Accept: 'application/json; charset=UTF-8',
        'Content-Type': 'text/plain; charset=UTF-8',
      },
    };
    return this.httpDeprecated.asPromise().withData(object).withConfig(config).post(url);
  }

  execRespMessageRequest(json, size, from, flowsUuid) {
    let _searchUrl = 'protected/search/searchOnSeveralTypes';

    let query = this.buildRespMessageEntryRequest(json, size, from, flowsUuid);
    return this.execSearchRequest(_searchUrl, JSON.stringify(query));
  }

  addPlayToRespMessage(respMessageUuid) {
    return this.httpDeprecated.asPromise().post('protected/responder/addPlayToRespMessage', respMessageUuid);
  }

  deleteRespMessage(respMessageId) {
    return this.httpDeprecated.asPromise().get('protected/responder/deleteRespMessage', respMessageId);
  }

  getDomainsOfPerimeter() {
    return this.httpDeprecated.asPromise().get('protected/user/getDomainsOfPerimeter', ['RESPONDER']);
  }

  getPerimeters() {
    return this.httpDeprecated.asPromise().get('protected/user/getPerimeters', ['RESPONDER']);
  }

  getFlows() {
    return this.httpDeprecated.asPromise().get('protected/responder/getOwnedMediaEntryPointList');
  }

  getRespMessageStatus(channelId) {
    let config = {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
        'Content-Type': 'text/plain; charset=UTF-8',
        Accept: 'text/plain; charset=UTF-8',
      },
    };
    return this.httpDeprecated.asPromise().withConfig(config).withData(channelId).post('protected/responder/getChannelStatus');
  }

  setRespMessageToRead(messageUuid) {
    return this.httpDeprecated.asPromise().post('protected/responder/setRespMessageToRead', messageUuid);
  }
}

export default 'responder';
